export function replacePlaceholders(
  copy: string,
  placeholders: {
    [p in string]?: string
  },
): string {
  return copy.replaceAll(
    /\[%s:(.+?)]/g,
    (_fullMatch, placeholderName: string) => placeholders[placeholderName] ?? '',
  )
}
